import type { FC, ReactNode } from 'react';
import { cn } from '@gokrew/ui/lib/utils';
import styles from './InfoCard.module.css';

interface InfoCardProps {
  title: string;
  subTitle?: string;
  className?: string;
  icon?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  subHeader?: ReactNode;
  footer?: ReactNode;
  /** Optional guided-tour anchor rendered as a `data-tour` attribute on the root. */
  dataTour?: string;
}

const InfoCard: FC<InfoCardProps> = ({
  title,
  subTitle,
  className,
  icon,
  action,
  children,
  subHeader,
  footer,
  dataTour,
}) => {
  return (
    <div
      data-tour={dataTour}
      className={cn(styles.card, className)}
    >
      <div className="flex items-center justify-between gap-2.5 w-full shrink-0">
        <div className="flex items-center gap-2">
          {icon && <div className={styles.iconWrap}>{icon}</div>}
          <div className="flex flex-col">
            <span className={styles.title}>{title}</span>
            <span className="text-gray-600 text-xs">{subTitle}</span>
          </div>
        </div>
        {action && <div>{action}</div>}
      </div>
      {subHeader && <div className="shrink-0">{subHeader}</div>}
      <div className={styles.body}>{children}</div>
      {footer && <div className="shrink-0">{footer}</div>}
    </div>
  );
};

export default InfoCard;
